import React from "react";
import myPartyStyles from "../MyParty/myParty.module.scss";
import "./GuestMode.scss";

interface PartyTabSkeletonProps {
  cardCount?: number;
  showGroupedLayout?: boolean;
}

const renderMyPartySkeletonCards = (cardCount: number) =>
  Array.from({ length: cardCount }, (_, index) => (
    <div className={myPartyStyles.wrapper} key={`my-party-skeleton-card-${index}`}>
      <div className={myPartyStyles.userInfoContainer}>
        <div className={`${myPartyStyles.userimage} loading-effect loading-effect-circle`} />
        <div className="mt-2">
          <div className="loading-effect loading-effect-text loading-effect-text-sm mx-auto" />
        </div>
      </div>

      <div className={myPartyStyles.clubInfoContainer}>
        <div className={myPartyStyles.dateBox}>
          <div className="loading-effect loading-effect-text loading-effect-text-md" />
        </div>

        <div className={myPartyStyles.clubeImgBox}>
          <div className={`${myPartyStyles.clubImage} loading-effect loading-effect-image`} />
          <div className={`${myPartyStyles.clubName} loading-effect loading-effect-title`} />
        </div>
      </div>
    </div>
  ));

const renderAlsoGoingOutSkeletonCards = (cardCount: number) =>
  Array.from({ length: cardCount }, (_, index) => (
    <div className="groupPromoter mb-3" key={`also-going-out-skeleton-card-${index}`}>
      <div className="desktopUI">
        <div className="datePm d-flex align-items-center w-100">
          <div className="loading-effect loading-effect-text loading-effect-text-md my-2 ms-3" />
        </div>

        <div className="text-center row align-items-stretch loading-effect-top-row">
          <div className="guestListTitle greyBorder col py-2 loading-effect-top-panel">
            <div className="loading-effect loading-effect-text loading-effect-text-sm mx-auto my-2" />
          </div>

          <div className="greyBorder d-flex justify-content-center align-items-center col py-2 loading-effect-top-panel loading-effect-stats-panel">
            <div className="loading-effect loading-effect-badge me-2" />
            <div className="loading-effect loading-effect-icon me-3" />
            <div className="loading-effect loading-effect-badge me-2" />
            <div className="loading-effect loading-effect-icon" />
          </div>

          <div className="dateCreated greyBorder d-flex flex-column align-items-center col py-2 loading-effect-top-panel">
            <div className="loading-effect loading-effect-text loading-effect-text-xs mt-1 mb-2" />
            <div className="loading-effect loading-effect-text loading-effect-text-sm" />
          </div>
        </div>

        <div className="text-center row mt-2 agesGroup align-items-center">
          <div className="col-auto ms-2">
            <div className="loading-effect loading-effect-text loading-effect-text-xs" />
          </div>
          <div className="col-auto">
            <div className="loading-effect loading-effect-text loading-effect-text-md" />
          </div>
        </div>

        <div className="d-flex invContainer mt-2">
          {Array.from({ length: 5 }, (_, invitationIndex) => (
            <div key={`also-going-out-avatar-${index}-${invitationIndex}`} className="ps-2 linkContainer">
              <div className="loading-effect loading-effect-circle loading-effect-avatar" />
            </div>
          ))}
        </div>

        <div className="row mt-2 align-items-center">
          <div className="col-auto ms-2 me-1">
            <div className="loading-effect loading-effect-text loading-effect-text-xs mb-0" />
          </div>
          <div className="col-auto p-0">
            <div className="loading-effect loading-effect-text loading-effect-text-lg mb-0" />
          </div>
        </div>

        <div className="row align-items-center mt-1">
          <div className="col-auto ms-2 me-1">
            <div className="loading-effect loading-effect-text loading-effect-text-xs" />
          </div>
          <div className="col-auto p-0">
            <div className="loading-effect loading-effect-text loading-effect-text-md" />
          </div>
        </div>
      </div>
    </div>
  ));

const PartyTabSkeleton: React.FC<PartyTabSkeletonProps> = ({
  cardCount = 3,
  showGroupedLayout = false,
}) => {
  return (
    <div data-testid="party-tab-skeleton" className="placeholder-glow">
      {showGroupedLayout ? (
        <>
          <div className="goingOutHeading d-flex w-100 mb-3" style={{ backgroundColor: "rgba(206, 140, 4, 0.5)" }}>
            <p className="w-100 py-2 mb-0">
              <span className="loading-effect loading-effect-text loading-effect-text-lg mx-auto" />
            </p>
          </div>
          {renderAlsoGoingOutSkeletonCards(cardCount)}
        </>
      ) : (
        renderMyPartySkeletonCards(cardCount)
      )}
    </div>
  );
};

export default PartyTabSkeleton;
